$(document).ready(function() {
    if(getCookie('show_cookie_message') != 'no') {
      $('#cookie_box').show().attr('aria-hidden', 'false');
    }
    $('.cookie_box_close').click(function() {
      var cookieBox = $('#cookie_box')
      cookieBox.animate({opacity:0 }, "slow");
      cookieBox.css({'max-height': '0', 'padding-top': '0', 'padding-bottom': '0'})
      setCookie('show_cookie_message','no');
      setTimeout(function () {
        cookieBox.css('display', 'none').attr('aria-hidden', 'true')
      }, 600)
      return false;
    });
  });
  function setCookie(cookie_name, value) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + (365*25));
    document.cookie = cookie_name + "=" + escape(value) + "; expires="+exdate.toUTCString() + "; path=/";
  }
  function getCookie(cookie_name) {
    if (document.cookie.length>0) {
      cookie_start = document.cookie.indexOf(cookie_name + "=");
      if (cookie_start != -1) {
        cookie_start = cookie_start + cookie_name.length+1;
        cookie_end = document.cookie.indexOf(";",cookie_start);
        if (cookie_end == -1) {
          cookie_end = document.cookie.length;
        }
        return unescape(document.cookie.substring(cookie_start,cookie_end));
      }
    }
    return "";
  }